import React, { useState, useEffect } from "react";
import Header from "../../../Components/adminDashboard/Header/Header";
import Accordion from "react-bootstrap/Accordion";
import categoryIcon from "../../../assets/images/cat_Icon.png";
import { useNavigate } from "react-router-dom";
import combinedServices from "../../../shared/services/user-service";
import moment from "moment";
import Swal from "sweetalert2";
import html2pdf from "html2pdf.js";

const OrderManagment = () => {
  const navigate = useNavigate();
  const [orderData, setOrderData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [searchQuery, setSearchQuery] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [updatedOrderStatus, setUpdatedOrderStatus] = useState("");
  const [refundedData, setRefundedData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [currentNote, setCurrentNote] = useState("");
  const [currentUserID, setCurrentUserID] = useState(null);
  const [currentEventID, setCurrentEventID] = useState(null);

  const totalPages = Math.ceil(totalOrders / limit);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const orderResponse = await combinedServices.getallorders(
          page,
          limit,
          searchQuery,
          paymentStatus,
          orderStatus
        );
        if (orderResponse?.data?.data) {
          setOrderData(orderResponse.data.data || []);
          setTotalOrders(orderResponse.data.total || 0);
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };
    fetchOrders();
  }, [
    page,
    limit,
    searchQuery,
    paymentStatus,
    orderStatus,
    updatedOrderStatus,
    refundedData,
    refreshTrigger
  ]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const handlePaymentStatusChange = (e) => {
    setPaymentStatus(e.target.value);
    setPage(1);
  };

  const handleOrderStatusChange = (e) => {
    setOrderStatus(e.target.value);
    setPage(1);
  };

  const groupedOrders = orderData.reduce((acc, order) => {
    if (!acc[order.order_id]) acc[order.order_id] = [];
    acc[order.order_id].push(order);
    return acc;
  }, {});

  const sortedGroupKeys = Object.keys(groupedOrders).sort(
    (a, b) =>
      new Date(groupedOrders[b][0].orderDate) -
      new Date(groupedOrders[a][0].orderDate)
  );

  const formatDate = (dateString) => {
    return moment(dateString).format("MM/DD/YYYY HH:mm:ss");
  };

  const updateOrderstatus = async (
    id,
    status,
    inv_id,
    userId,
    product_id,
    attribute,
    product
  ) => {
    try {
      const confirmResult = await Swal.fire({
        title: "Are you sure?",
        text: `You are about to update the order status to "${status}".`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "No, cancel"
      });

      if (!confirmResult.isConfirmed) {
        return;
      }

      Swal.fire({
        title: "Updating...",
        text: "Please wait while we update the order status.",
        icon: "info",
        showConfirmButton: false,
        allowOutsideClick: false,
        timerProgressBar: true
      });

      const statusData = { id, status };
      const orderUpdateResponse = await combinedServices.updateOrderstatus(
        statusData
      );
      if (status === "Cancelled") {
        const parsedAttribute = JSON.parse(attribute);
        if (
          (parsedAttribute.Classes || parsedAttribute.Transponders) &&
          inv_id === 0 &&
          product === null
        ) {
          const cancelUserEventEntryResponse =
            await combinedServices.cancelUserEventEntry({
              id: id,
              userID: userId,
              eventId: product_id
            });
          setRefreshTrigger((prev) => prev + 1);
        }
      }
      if (orderUpdateResponse?.data) {
        setUpdatedOrderStatus(orderUpdateResponse.data || []);

        Swal.fire({
          title: "Success!",
          text: orderUpdateResponse.data.message,
          icon: "success"
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to update the order status. Please try again.",
          icon: "error"
        });
      }
    } catch (error) {
      console.error("Error Updating orders:", error);

      Swal.fire({
        title: "Error!",
        text: "An error occurred while updating the order status.",
        icon: "error"
      });
    }
  };

  const getStatusClass = (status, type) => {
    if (type === "payment") {
      return (
        {
          COMPLETED: "status-completed-delivered",
          PENDING: "status-pending",
          FAILED: "status-failed-cancelled"
        }[status] || "status-default"
      );
    }
    if (type === "order") {
      return (
        {
          Delivered: "status-completed-delivered",
          Pending: "status-pending",
          Cancelled: "status-failed-cancelled"
        }[status] || "status-default"
      );
    }
  };

  const cancelOrder = async (id, payment_id, price, inv_id, storeid) => {
    console.log('storeid', storeid)
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to cancel this order?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "No, keep it"
      });

      if (result.isConfirmed) {
        setIsLoading(true);

        const data = {
          id: id,
          payment_id: payment_id,
          refundableAmount: price,
          inv_id: inv_id,
          storeid: storeid
        };

        const CancelOrderResponse = await combinedServices.CancelOrder(data);
        console.log("CancelOrderResponse", CancelOrderResponse.data.status);

        if (CancelOrderResponse.data.status === 200) {
          setRefundedData("REFUNDED");
          Swal.fire(
            "Cancelled!",
            "Your order has been successfully cancelled.",
            "success"
          );
          setIsLoading(false);
        } else {
          Swal.fire("Failed!", "Failed to cancel the order.", "error");
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      Swal.fire(
        "Error!",
        "An error occurred while cancelling the order.",
        "error"
      );
      setIsLoading(false);
    }
  };

  const createImageWithOpacity = (base64Img, opacity) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // avoid CORS if possible
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.globalAlpha = opacity; // set opacity here (0.4)
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        resolve(canvas.toDataURL("image/png", 0.8));
      };
      img.onerror = () => {
        resolve(base64Img);
      };
      img.src = base64Img;
    });
  };

  const addDates = async (fromDate, toDate) => {
    try {
      const { value: formValues } = await Swal.fire({
        title: "Enter Date Range",
        html: `<div style="display: flex; justify-content: center; gap: 20px; width: 100%; padding: 0 20px;">
              <div style="flex: 1; display: flex; flex-direction: column; align-items: center;">
                <label for="swal-input1" style="margin-bottom: -10px; font-weight: bold;">From Date</label>
                <input id="swal-input1" class="swal2-input" placeholder="From Date" type="date" style="width: 100%; max-width: 200px;" ${fromDate ? `value="${fromDate}"` : ""
          }>
              </div>
              <div style="flex: 1; display: flex; flex-direction: column; align-items: center;">
                <label for="swal-input2" style="margin-bottom: -10px; font-weight: bold;">To Date</label>
                <input id="swal-input2" class="swal2-input" placeholder="To Date" type="date" style="width: 100%; max-width: 200px;" ${toDate ? `value="${toDate}"` : ""
          }>
              </div>
            </div>`,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Generate Report",
        width: "700px",
        padding: "2em",
        backdrop: true,
        customClass: {
          container: "custom-swal-container",
          popup: "custom-swal-popup",
          input: "custom-swal-input"
        },
        preConfirm: () => {
          return [
            document.getElementById("swal-input1").value,
            document.getElementById("swal-input2").value
          ];
        }
      });

      if (formValues) {
        const [fromDate, toDate] = formValues;
        if (!fromDate || !toDate) {
          Swal.fire("Error!", "Please enter both From and To dates.", "error");
          return;
        }
        const fromDateUTC = new Date(`${fromDate}T00:00:00Z`).toISOString();
        const toDateUTC = new Date(`${toDate}T23:59:59Z`).toISOString();

        const response = await combinedServices.orderData({
          fromDate: fromDateUTC,
          toDate: toDateUTC
        })

        if (response.status === 200) {
          console.log('adsadasd', response)
          generateOrderPDF(response.data.orderData);

          Swal.fire(
            "Success!",
            response.data.message || "Report generated successfully.",
            "success"
          );
        } else {
          Swal.fire(
            "Warning!",
            "An unexpected response was received while generating the report.",
            "warning"
          );
        }
      }
    } catch (error) {
      console.error("Error generating report:", error);
      Swal.fire("Error!", "Failed to generate the report.", "error");
    }
  };

  const generateOrderPDF = async (orders) => {
    const ordersGrouped = orders.reduce((acc, order) => {
      if (!acc[order.order_id]) {
        acc[order.order_id] = [];
      }
      acc[order.order_id].push(order);
      return acc;
    }, {});

    const DEFAULT_IMAGE = 'https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/logo.png';
    let backgroundImageBase64 = null;

    try {
      const relevantItems = orders.filter((item) => {
        try {
          const attributes = JSON.parse(item.attribute || "{}");
          return Object.keys(attributes).some(
            (key) => key.startsWith("Classes") || key.startsWith("Transponders")
          );
        } catch {
          return false;
        }
      });

      if (relevantItems.length > 0) {
        for (const item of relevantItems) {
          try {
            if (item.image) {
              const imageurl = JSON.parse(item.image);
              const body = { url: imageurl[0]?.url || imageurl[0] || DEFAULT_IMAGE };
              const urltobase64 = await combinedServices.UrlToBase64(body);
              if (urltobase64?.data?.base64img) {
                backgroundImageBase64 = urltobase64.data.base64img;
                break;
              }
            }
          } catch (error) {
            console.error('Error processing item image:', error);
          }
        }
      }

      if (!backgroundImageBase64 && orders.length > 0) {
        backgroundImageBase64 = orders[0].base64img;
      }

      if (!backgroundImageBase64) {
        const body = { url: DEFAULT_IMAGE };
        const urltobase64 = await combinedServices.UrlToBase64(body);
        backgroundImageBase64 = urltobase64?.data?.base64img;
      }
    } catch (error) {
      console.error('Error processing background image:', error);
    }

    const orderHTMLs = Object.entries(ordersGrouped).map(([orderId, orderItems]) => {
      const firstItem = orderItems[0];

      return `
      <div class="order-group">
        <header>
          <h1>NAMBA 2025 Nationals</h1>
          <h2>Order Report</h2>
        </header>

        <section class="customer-info">
          <div class="customer-left">
            <div><span class="label">${firstItem?.username || "N/A"}</span></div>
            <div class="info-grid">
              <div class="grid-item">
                <div class="label">#</div>
                <div>${firstItem?.userId || "N/A"}</div>
              </div>
              <div class="grid-item">
                <div class="label">Email</div>
                <div>${firstItem?.email || "N/A"}</div>
              </div>
              <div class="grid-item">
                <div class="label">Home Phone</div>
                <div>${firstItem?.phone || "N/A"}</div>
              </div>
              <div class="grid-item">
                <div class="label">Mobile Phone</div>
                <div>${firstItem?.phone || "N/A"}</div>
              </div>
            </div>
          </div>
        </section>

        <section class="customer-info">
          <div class="customer-left">
            <div class="info-grid2">
              <div class="grid-item">
                <div class="label">Order</div>
                <div>${firstItem?.order_id || "N/A"}</div>
              </div>
              <div class="grid-item">
                <div class="label">Order Date</div>
                <div>${formatDate(firstItem?.orderDate) || "N/A"}</div>
              </div>
              <div class="grid-item">
                <div class="label">Order Status</div>
                <div>${firstItem?.orderStatus || "N/A"}</div>
              </div>
              <div class="grid-item">
                <div class="label">Payment Status</div>
                <div>${firstItem?.paymentStatus || "N/A"}</div>
              </div>
              <div class="grid-item">
                <div class="label">Transaction ID</div>
                <div>${firstItem?.transaction_id || "N/A"}</div>
              </div>
            </div>
          </div>
        </section>
        
        <section>
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Qty</th>
                <th>Price</th>
                <th>Extended Price</th>
              </tr>
            </thead>
            <tbody>
              ${orderItems
          .map((item) => {
            const attributes = JSON.parse(item.attribute || "{}");
            const attributeText = Object.entries(attributes)
              .map(
                ([key, value]) =>
                  `${key}: ${Array.isArray(value) ? value.join(", ") : value}`
              )
              .join("; ");

            return `
                    <tr>
                      <td>
                        ${item.product_name || "N/A"}
                        ${attributeText
                ? `<span class="item-desc">${attributeText}</span>`
                : ""
              }
                      </td>
                      <td>${item.quantity}</td>
                      <td>$${item.unit_price || "0.00"}</td>
                      <td>$${(item.quantity * item.unit_price)?.toFixed(2) || "0.00"}</td>
                    </tr>
                  `;
          })
          .join("")}
            </tbody>
          </table>

          <div class="total-line">
            $${orderItems
          .reduce(
            (total, item) => total + item.quantity * item.unit_price,
            0
          )
          .toFixed(2)} Total
          </div>
        </section>
      </div>
    `;
    });

    const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>NAMBA 2025 Nationals</title>
        <style>
          /* Base styles */
          body {
            font-family: "Times New Roman", Times, serif;
            font-size: 14px;
            margin: 40px 60px;
            color: #000;
            line-height: 1.3;
            font-weight: bold;
            position: relative;
            min-height: 100vh;
          }

          .watermark {
            position: fixed;
            top: 30%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 400px;
            height: 250px;
            background-position: center center;
            background-size: contain;
            background-repeat: no-repeat;
            opacity: 0.3;
            z-index: -1;
            pointer-events: none;
          }
          
          h1 {
            font-size: 22px;
            margin: 0;
            text-align: center;
          }
          
          h2 {
            font-size: 18px;
            margin: 0 0 20px 0;
            text-align: center;
            font-weight: normal;
          }
          
          /* Customer info section - responsive */
          .customer-info {
            margin-bottom: 15px;
            font-size: 13px;
          }
          
          .customer-header {
            font-weight: bold;
            margin-bottom: 8px;
          }
          
          .info-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 10px;
            margin-bottom: 15px;
          }
          
          .info-grid2 {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
            gap: 10px;
          }
          
          .grid-item {
            display: flex;
            flex-direction: column;
            min-width: 0;
          }
          
          .label {
            font-weight: bold;
            margin-bottom: 3px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          .grid-item div:not(.label) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          /* Items table */
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 13px;
            margin-bottom: 5px;
            page-break-inside: avoid;
          }
          
          th, td {
            border: 1px solid black;
            padding: 5px 8px;
            vertical-align: top;
          }
          
          th {
            font-weight: bold;
            background-color: #e6e6e6;
            text-align: left;
          }
          
          /* Item descriptions */
          .item-desc {
            font-style: italic;
            font-size: 12px;
            padding-top: 3px;
            display: block;
            color: #222;
          }
          
          /* Total line */
          .total-line {
            font-weight: bold;
            text-align: right;
            margin-top: 10px;
            font-size: 14px;
            page-break-after: avoid;
          }
          
          /* Notes */
          .notes {
            margin-top: 25px;
            font-size: 13px;
          }
          
          .notes strong {
            font-weight: bold;
          }
          
          /* Footer */
          footer {
            margin-top: 40px;
            text-align: center;
            font-size: 12px;
            color: #444;
            border-top: 1px solid #ccc;
            padding-top: 8px;
          }
          
          /* Order group styling */
          .order-group {
            page-break-after: always;
            margin-bottom: 40px;
          }
          
          .order-group:last-child {
            page-break-after: avoid;
          }
        </style>
      </head>
      <body>
        ${backgroundImageBase64 ? `<div class="watermark" style="background-image: url('${backgroundImageBase64}');"></div>` : ''}
        
        ${orderHTMLs.join('')}

        <footer>
          ${new Date().toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    })} 
        </footer>
      </body>
    </html>
  `;

    const element = document.createElement('div');
    element.innerHTML = htmlContent;

    const opt = {
      margin: [10, 10, 10, 10],
      filename: `namba_orders_report_${new Date().toISOString().split('T')[0]}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
        letterRendering: true
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    await html2pdf().set(opt).from(element).save();

    element.remove();
  };



  const handleOpenNoteModal = (note, userId, eventid) => {
    console.log('asdasdsa,', note, userId, eventid)
    setCurrentNote(note);
    setCurrentUserID(userId);
    setCurrentEventID(eventid)
    setShowNoteModal(true);
  };

  const handleCloseNoteModal = () => {
    setShowNoteModal(false);
    setCurrentNote("");
    setCurrentEventID("")
    setCurrentUserID(null);
  };

  const handleSaveNote = async () => {
    try {
      if (!currentEventID && !currentUserID) return;

      const response = await combinedServices.changeSpecialNote({
        userID: currentUserID,
        eventID: currentEventID,
        specialNote: currentNote
      });
      if (response.data.status) {
        setRefreshTrigger((prev) => prev + 1);
        Swal.fire("Success!", response.data.message, "success");
      } else {
        throw new Error(response.data.message || "Failed to update note");
      }
    } catch (error) {
      console.error("Error updating special note:", error);
      Swal.fire("Error!", error.message, "error");
    } finally {
      handleCloseNoteModal();
    }
  };

  return (
    <>
      <Header />
      <div className="dbAdminRight newDbRight">
        <div className="dbMid dbInner">
          {isLoading && (
            <div className="loadingOverlay">
              <div className="loadingSpinner"></div>
            </div>
          )}
          <div className="dbMainHd">Order Management</div>
          <div className="catFilterWrp">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="catFilterCont">
                <div className="filWrp">
                  <label className="label2">Showing</label>
                  <select
                    value={limit}
                    onChange={handleLimitChange}
                    className="form_ctrl ctrlDrop"
                  >
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ent">entries</span>
                  <div className="filBtnWrp">
                    <label className="label2">Payment Status</label>
                    <select
                      value={paymentStatus}
                      onChange={handlePaymentStatusChange}
                      className="form_ctrl ctrlDrop"
                    >
                      <option value="">All Payment</option>
                      <option value="COMPLETED">Completed</option>
                      <option value="PENDING">Pending</option>
                      <option value="FAILED">Failed</option>
                    </select>
                    <span className="ent"></span>

                    <div className="srchGrp">
                      <label className="label2">Order Status</label>

                      <select
                        value={orderStatus}
                        onChange={handleOrderStatusChange}
                        className="form_ctrl ctrlDrop"
                      >
                        <option value="">All Orders</option>
                        <option value="Delivered">Delivered</option>
                        <option value="Pending">Pending</option>
                        <option value="Cancelled">Cancelled</option>
                      </select>
                    </div>
                  </div>
                  <span className="ent"></span>

                  <div className="srchGrp">
                    <input
                      type="text"
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="form_ctrl ctrlSrch"
                      placeholder="Search with Order ID, Product Name or User Name"
                    />
                  </div>
                  <div>
                    <button style={{ marginLeft: 60 }}
                      className="date-button"
                      onClick={() => addDates(null, null, null, null, false)}
                    >
                      Download All Report
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="listTablWrp">
            <div className="tblWrp">
              {/* Table headers */}
              <table>
                <thead>
                  <tr>
                    <th className="orderTableminweidth">User Name</th>
                    <th className="orderTableminweidth">
                      Product / Event Name
                    </th>
                    <th className="orderTableminweidth">Description</th>
                    <th className="orderTableminweidth">Quantity</th>
                    <th className="orderTableminweidth">Price</th>
                    <th className="orderTableminweidth">Total</th>
                    <th className="orderTableminweidth">Payment Status</th>
                    <th className="orderTableminweidth">Order Status</th>
                    <th className="orderTableminweidth">Special Note</th>
                    <th className="orderTableminweidth">Transaction ID</th>
                    <th className="orderTableminweidth">Ordered Date</th>
                    <th className="orderTableminweidth">Action</th>
                  </tr>
                </thead>
              </table>
              <Accordion defaultActiveKey="0">
                {sortedGroupKeys.map((orderId, idx) => {
                  const ordersWithSameId = groupedOrders[orderId];
                  return (
                    <Accordion.Item eventKey={String(idx)} key={orderId}>
                      <Accordion.Header>
                        <div className="accordion-header-content">
                          <div>
                            <strong>Order ID:</strong> {orderId}{" "}
                            <strong>Username:</strong>{" "}
                            {ordersWithSameId[0]?.username || "N/A"}{" "}
                            <strong>Order Date:</strong>{" "}
                            {formatDate(ordersWithSameId[0]?.orderDate) ||
                              "N/A"}{" "}
                            {/* <strong>Payment Date:</strong>{" "}
                            {formatDate(ordersWithSameId[0]?.paymentDate) ||
                              "N/A"} */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end"
                              }}
                            >
                              <button
                                className="nambaBtn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  generateOrderPDF(ordersWithSameId);
                                }}
                                style={{
                                  padding: "10px 50px",
                                  marginTop: "-20px",
                                  borderRadius: "5px"
                                }}
                              >
                                Download Report
                              </button>
                            </div>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <table>
                          <tbody>
                            {ordersWithSameId.map((order) => {
                              const product = order.product || {};
                              const images = JSON.parse(order.image || "[]");
                              const orderAttributes = JSON.parse(
                                order.attribute || "{}"
                              );
                              const totalPrice =
                                order.quantity * order.unit_price;

                              return (
                                <tr key={order.id}>
                                  <td className="orderTableminweidth">
                                    {order.username}
                                  </td>
                                  <td className="orderTableminweidth">
                                    <div className="catPara">
                                      <img
                                        src={images[0] || categoryIcon}
                                        alt={
                                          order.product_name || "Product Image"
                                        }
                                      />
                                      {order.product_name || "N/A"}
                                    </div>
                                  </td>
                                  <td className="orderTableminweidth">
                                    {Object.keys(orderAttributes).length > 0 ? (
                                      Object.entries(orderAttributes).map(
                                        ([key, value]) => (
                                          <div key={key}>
                                            <strong>{key}:</strong>{" "}
                                            {Array.isArray(value)
                                              ? value.join(", ")
                                              : value}
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <span>N/A</span>
                                    )}
                                  </td>

                                  <td className="orderTableminweidth">
                                    {order.quantity}
                                  </td>
                                  <td className="orderTableminweidth">
                                    ${order.unit_price || "N/A"}
                                  </td>
                                  <td className="orderTableminweidth">
                                    ${totalPrice.toFixed(2)}
                                  </td>
                                  <td>
                                    <span
                                      className={`status-badge ${getStatusClass(
                                        order.paymentStatus,
                                        "payment"
                                      )}`}
                                    >
                                      {order.paymentStatus}
                                    </span>
                                  </td>
                                  <td className="orderTableminweidth">
                                    <div className="orderStatus ">
                                      <select
                                        value={order.orderStatus || "Pending"}
                                        onChange={(e) =>
                                          updateOrderstatus(
                                            order.id,
                                            e.target.value,
                                            order.inv_id,
                                            order.userId,
                                            order.product_id,
                                            order.attribute,
                                            order.product
                                          )
                                        }
                                        className={`form_ctrl ctrlDrop ${getStatusClass(
                                          order.orderStatus,
                                          "order"
                                        )} ${order.paymentStatus !== "COMPLETED" ||
                                          order.orderStatus === "Delivered" ||
                                          order.orderStatus === "Cancelled"
                                          ? "disabled-select"
                                          : ""
                                          }`}
                                        disabled={
                                          order.paymentStatus !== "COMPLETED" ||
                                          order.orderStatus === "Delivered" ||
                                          order.orderStatus === "Cancelled"
                                        }
                                      >
                                        <option value="Delivered">
                                          DELIVERED
                                        </option>
                                        <option value="Pending">PENDING</option>
                                        <option value="Cancelled">
                                          CANCELLED
                                        </option>
                                      </select>
                                    </div>
                                  </td>
                                  <td className="td1">
                                    <span
                                      className='catPara'
                                    >
                                      {order.special_note || "N/A"}
                                    </span>
                                    {order.special_note && (
                                      <button
                                        onClick={() => handleOpenNoteModal(order.special_note, order.userId, order.product_id)}
                                        className="btn-edit-note"
                                        style={{
                                          background: "none",
                                          border: "none",
                                          color: "#1890ff",
                                          cursor: "pointer",
                                          padding: "0 5px"
                                        }}
                                      >
                                        Edit
                                      </button>
                                    )}
                                  </td>
                                  <td className="orderTableminweidth">
                                    {order.transaction_id || "N/A"}
                                  </td>
                                  <td className="orderTableminweidth">
                                    {formatDate(order.orderDate) || "N/A"}
                                  </td>
                                  <td>
                                    <button
                                      className={`status-badge ${order.paymentStatus === "COMPLETED" &&
                                        order.orderStatus === "Cancelled"
                                        ? "status-failed-cancelled"
                                        : "status-default"
                                        }`}
                                      disabled={
                                        order.paymentStatus !== "COMPLETED" ||
                                        order.orderStatus !== "Cancelled"
                                      }
                                      onClick={() => {
                                        cancelOrder(
                                          order.id,
                                          order.payment_id,
                                          order.price,
                                          order.inv_id,
                                          order.store_id
                                        );
                                      }}
                                    >
                                      Initiate Refund
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>
            </div>

            {/* Pagination */}
            <div className="tblPagiWrp">
              <ul className="pagination namPagi">
                <li>
                  <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                  >
                    Prev
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => (
                  <li key={index}>
                    <button
                      className={page === index + 1 ? "active" : ""}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li>
                  <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {showNoteModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Edit Special Note</h3>
              <button onClick={handleCloseNoteModal} className="modal-close">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <textarea
                value={currentNote}
                onChange={(e) => setCurrentNote(e.target.value)}
                className="form_ctrl"
                rows={5}
                style={{ width: "100%" }}
              />
            </div>
            <div className="modal-footer">
              <button onClick={handleCloseNoteModal} className="btn btn-secondary">
                Cancel
              </button>
              <button onClick={handleSaveNote} className="btn btn-primary">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderManagment;
